import _classCallCheck from "/codebuild/output/src2790546665/src/inspectappreact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/codebuild/output/src2790546665/src/inspectappreact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src2790546665/src/inspectappreact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src2790546665/src/inspectappreact/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
export var BsPrefixComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(BsPrefixComponent, _React$Component);
  function BsPrefixComponent() {
    _classCallCheck(this, BsPrefixComponent);
    return _possibleConstructorReturn(this, _getPrototypeOf(BsPrefixComponent).apply(this, arguments));
  }
  return BsPrefixComponent;
}(React.Component);

// Need to use this instead of typeof Component to get proper type checking.

export function getOverlayDirection(placement, isRTL) {
  var bsDirection = placement;
  if (placement === 'left') {
    bsDirection = isRTL ? 'end' : 'start';
  } else if (placement === 'right') {
    bsDirection = isRTL ? 'start' : 'end';
  }
  return bsDirection;
}